/* Swipe the native thumbnail gallery using its existing selection controls. */
(() => {
  let start = null;
  let suppressClickUntil = 0;
  document.addEventListener('touchstart', event => {
    start = null;
    if (!matchMedia('(max-width: 767px)').matches || event.touches.length !== 1) return;
    const gallery = event.target.closest('product-media-variants[data-layout="thumbnails"]');
    if (!gallery || event.target.closest('.product-media--thumb, video, model-viewer, button')) return;
    const touch = event.touches[0];
    start = {gallery, x: touch.clientX, y: touch.clientY};
  }, {passive: true});
  document.addEventListener('touchend', event => {
    if (!start) return;
    const {gallery, x, y} = start;
    start = null;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - x;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(touch.clientY - y) * 1.5) return;
    const thumbs = [...gallery.querySelectorAll('.product-media--thumb')];
    const current = thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
    const next = current + (dx < 0 ? 1 : -1);
    if (current < 0 || !thumbs[next]) return;
    suppressClickUntil = Date.now() + 500;
    thumbs[next].click();
    thumbs[next].scrollIntoView({block: 'nearest', inline: 'nearest'});
  }, {passive: true});
  document.addEventListener('touchcancel', () => { start = null; }, {passive: true});
  document.addEventListener('click', event => {
    if (event.isTrusted && Date.now() < suppressClickUntil && event.target.closest('product-media-variants')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
})();
